module.exports = __webpack_public_path__ + "static/media/business-type.b7072533.png";